

















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TranslateResult } from 'vue-i18n';
import { EAddons } from '@/plugins/podolib/services/addons';

type TLinks = {
  name: string;
  title: TranslateResult;
  icon: string;
  // to: string;
  badge: boolean | number;
  disabledInDemo?: boolean;
};

@Component
export default class BaseSidebar extends Vue {
  windowWidth = 0;

  get links(): TLinks[] {
    return [
      {
        name: 'home',
        title: this.$t('commons.standards.home'),
        icon: '$vuetify.bars',
        badge: false,
      },
      {
        name: 'patients',
        title: this.$tc('commons.standards.patient', 2),
        icon: '$vuetify.users',
        badge: false,
      },
      {
        name: 'equipments',
        title: this.$tc('commons.standards.equipment', 2),
        icon: '$vuetify.suitcase',
        badge: !!this.notUpdatedorCalibratedSoles,
        disabledInDemo: true,
      },
      {
        name: 'settings',
        title: this.$tc('commons.standards.setting', 2),
        icon: '$vuetify.cogs',
        badge: false,
      },
    ];
  }

  get addons() {
    const _addons = Object.values(EAddons);
    const _active = this.$store.getters['pdc/addons/getActiveAddons'];

    return _addons.map((x) => ({
      id: x,
      active: _active.includes(x),
    }));
  }

  get miniVariant(): boolean {
    return this.$pdc.storage!.getUniversal('miniVariant');
  }

  get soles() {
    return this.$pdc.entities!.soles.storedEntity.list;
  }

  get notUpdatedorCalibratedSoles() {
    return this.soles.filter((x: any) => x.updatable);
  }

  set miniVariant(value: boolean) {
    this.$pdc.storage!.setUniversal('miniVariant', value);
  }

  @Watch('windowWidth')
  onwindowWidthChange(val: number) {
    if (val <= 1200) this.$pdc.storage!.setUniversal('miniVariant', true);
  }

  analytics({ name, isExternal = false }: { name: string; isExternal?: boolean }) {
    // Analytics
    this.$pdc.analytics?.actions.trackSuccess('Sidebar NavClicked', {
      name,
      isExternal,
    });
  }

  toggleMiniVariant() {
    this.miniVariant = !this.miniVariant;

    // Analytics
    this.$pdc.analytics?.actions.trackSuccess('Sidebar Minimized', {
      isMinimized: this.miniVariant,
    });
  }

  created() {
    this.$pdc.storage!.syncUniversal('miniVariant', false);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.windowWidth = window.innerWidth;
  }
}
